/**
 * DEV NOTE: A new source apps needs to be added to the `sourceApps` variable in
 * automation-ui-core/static/js/context/AppContext.tsx
 *
 */
export const ADS_FLOW = 'ADS_FLOW';
export const CMS_FORM_MODULE_FIELD = 'CMS_FORM_MODULE_FIELD';
export const CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL = 'CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL';
export const CRM_MIGRATION = 'CRM_MIGRATION';
export const DEAL_PIPELINE_SETTINGS = 'DEAL_PIPELINE_SETTINGS';
export const DIRECT_API = 'DIRECT_API';
export const PUBLIC_API = 'PUBLIC_API';
export const ECOMM = 'ECOMM';
export const EMBEDDED_QUOTES = 'EMBEDDED_QUOTES';
export const FEEDBACK = 'FEEDBACK';
export const FEEDBACK_FOLLOW_UP = 'FEEDBACK_FOLLOW_UP';
export const FORECASTING = 'FORECASTING';
export const FORM_FIELD_FOLLOWUP = 'FORM_FIELD_FOLLOWUP';
export const FORM_FOLLOWUP_EMAIL = 'FORM_FOLLOWUP_EMAIL';
export const FORMS_APP = 'FORMS_APP';
export const LEAD_FLOW = 'LEAD_FLOW'; // will be deprecated once contextual automation is live

export const LEAD_FLOWS_APP = 'LEAD_FLOWS_APP';
export const MARKETING_EMAIL_AUTOMATED = 'MARKETING_EMAIL_AUTOMATED';
export const SEQUENCES_CONTEXTUAL_AUTOMATION = 'SEQUENCES_CONTEXTUAL_AUTOMATION';
export const SKILL_BASED_ROUTING = 'SKILL_BASED_ROUTING';
export const TICKET_EMAIL_STATUS_SETTING = 'TICKET_EMAIL_STATUS_SETTING';
export const TICKET_PIPELINE_SETTINGS = 'TICKET_PIPELINE_SETTINGS';
export const WORKFLOWS_APP = 'WORKFLOWS_APP';
export const WORKFLOWS_CLASSIC = 'WORKFLOWS_CLASSIC'; // never passed by BE
// export const AUTOMATION_PLATFORM_INTERNAL = 'AUTOMATION_PLATFORM_INTERNAL';